import React, { useEffect, useState } from "react";
import { Row, Button, Modal, Form } from "react-bootstrap";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import api from "../../seller-apis/api";
import "./UpdtProPopup.css";
import { useAlert } from "react-alert";
import {
  pendforapprovProducts,
  pendingProducts,
} from "../../seller-apis/apidataField";
import { setInitialPackages } from "../../Actions/PackageWeight";

import WeightComponent from "../common/WeightComponent";
import { useDispatch, useSelector } from "react-redux";
import { packagesFttoCm } from "../../utilities/conversion";
import { resetPackages } from "../../Actions/PackageWeight";
import { sanitizePkgImages } from "../../utilities/packages";
import variables from '../../Variables.json'
let isNewVend;
let NewVendTotalprcount;
function UpdtProPopup2(props) {

  const alert = useAlert();
  isNewVend = false;
  NewVendTotalprcount = 0;
  const [quantity, setquantity] = useState();
  const [price, setPrice] = useState("");
  const [cataloguePage, SetCataloguePage] = useState(0)

  // Toast States
  const [toastprice, settoastprice] = useState("none");
  const [priceToastMsg, setpriceToastMsg] = useState();

  const [stockToast, setstockToast] = useState("none");
  const [stockToastMsg, setstockToastMsg] = useState();


  // For product detail page
  const [selValscombcol, setselValscombcol] = useState([0, 0]);
  const [selValscombrow, setselValscombrow] = useState([0, 1]);

  // Combination handling

  const [curComurl, setcurComurl] = useState(undefined);
  const [isCombPresent, setisCombPresent] = useState();
  const [currcombshow, setcurrcombshow] = useState([]);
  const [currcombsel, setcurrcombsel] = useState([]);
  const [isVerifiedSeller, setisVerifiedSeller] = useState(false);

  // For switch button combination

  const [check, setChecked] = useState(true);
  const [inActiveCheck, setinActiveCheck] = useState(false);
  const [pkgs, setPkgs] = useState([]);
  const [pkgsValidation, setPkgsValidation] = useState(0);

  // Change GST

  const [gst, setGst] = useState("");
  const [pkgChanged, setPkgChanged] = useState(false);
  const [weightLocked, setWeightLocked] = useState(false);
  const [confirmLockedWeight, setConfirmLockedWeight] = useState(false);
  //SL-660
  const [grabOrderUpdate, setGrabOrderUpdate] = useState(false);

  //I1-2203
  const PRICE_MARGIN_PERCENTAGE = 25;


  // sl-712
  const [attrbs, setattrbs] = useState([]);
  const dispatch = useDispatch()
  const { packages } = useSelector(state => state.packageReducer)


  //add product popup not show issue solve 
  useEffect(() => {
    let propPkgs = [];
    let propPkgs2 = [];
    if (props?.detail?.pkgs && props?.detail?.pkgs?.length > 0) {
      for (const pkg of props?.detail?.pkgs) {
        if (pkg?.status == "APPROVED") {
          propPkgs2.push(pkg);
          pkg["packageWidthFront"] = (pkg.packageWidth / 30.48).toFixed(2);
          pkg["packageHeightFront"] = (pkg.packageHeight / 30.48).toFixed(2);
          pkg["packageLengthFront"] = (pkg.packageLength / 30.48).toFixed(2);
          propPkgs.push(pkg);
        }
      }
    }
    dispatch(setInitialPackages([...propPkgs2]));

    setPkgs([...propPkgs]);
  }, [props.pkgs]);
  useEffect(() => {
    setGst(props.detail.taxClass);

    if (props.from === "appPro_detail") {
      let i = 0;
      for (const attr of props.combattr) {
        attr.selectedValue = attr.values[0];
      }

      setPrice(props.firstPrice);
      setPrice(props.pPrice);
      setcurrcombsel(props.vendorfirstComb);
      let selectedele = document.getElementById("combind" + 0 + "es" + 0);
      selectedele.click();
    }
    let body = {};

    api.auth
      .me(body)
      .then((res) => {
        if (res.message === "seller fetched") {
          setisVerifiedSeller(true);
          let filter = {
            pageNo: "1",
          };
          // New request for approval Products
          api.product
            .vExPrdReqRetrieveAll(pendforapprovProducts(filter))
            .then((res) => {
              NewVendTotalprcount = NewVendTotalprcount + res.totalRecords;
            })
            .catch((err) => console.log(err));

          // // Pending products
          api.product
            .newProductsRetrieveall(pendingProducts(filter))
            .then((res) => {
              NewVendTotalprcount = NewVendTotalprcount + res.totalRecords;
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((err) => console.log(err));
  }, []);

  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }

  function showPkgEdit(pkgId) {

    const nextPkgs = [...pkgs];
    const pkg = nextPkgs.find((a) => a._id === pkgId);
    pkg.pkgEdit = !pkg.pkgEdit;
    setPkgs(nextPkgs);
  }

  function handlePkgChange(pkgId, key, value) {

    const nextPkgs = [...pkgs];
    const pkg = nextPkgs.find((a) => a._id === pkgId);
    if (!value || value <= 0) {

      const pkgVal = pkgsValidation + 1;
      setPkgsValidation(pkgVal);
      pkg[key] = value;
      if (key == "packageWidth") {
        pkg["packageWidthFront"] = value;
      } else if (key == "packageHeight") {
        pkg["packageHeightFront"] = value;
      } else if (key == "packageLength") {
        pkg["packageLengthFront"] = value;
      }
    } else {
      const pkgVal = pkgsValidation - 1;
      setPkgsValidation(pkgVal);
      if (
        key == "packageWidth" ||
        key == "packageHeight" ||
        key == "packageLength"
      ) {
        pkg[key] = (value * 30.48).toFixed(2);
        if (key == "packageWidth") {
          pkg["packageWidthFront"] = value;
        } else if (key == "packageHeight") {
          pkg["packageHeightFront"] = value;
        } else {
          pkg["packageLengthFront"] = value;
        }

        pkg.vWeight =
          (pkg.packageWidth * pkg.packageLength * pkg.packageHeight) / 5000;
        pkg.vWeight = pkg.vWeight.toFixed(2);
      } else {
        pkg[key] = value;
      }
    }
    setPkgs(nextPkgs);
    setPkgChanged(true);
  }

  // select variants
  // sl - 712
  function checkVariant(grp, ind) {
    // setPriceReqType("changeReq");
    // setWeightLocked(false);
    // setvendToolHistArr([]);
    let product = props.detail.product;
    let arr = [];
    let selectedele = document.getElementById("combind" + grp + "es" + ind);
    let btns = document.getElementsByClassName("shed combgrp" + grp);
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].classList.contains("combactive")) {
        btns[i].classList.remove("combactive");
      }
    }
    selectedele.classList.add("combactive");
    let cmbString = [];

    for (const attr of product.attributeList) {
      if (!attr.selectedValue) {
        return;
      }
      cmbString[product.combination[0].value.indexOf(attr.attribute.name)] =
        attr.selectedValue;
      arr.push(
        cmbString[product.combination[0].value.indexOf(attr.attribute.name)]
      );
    }

    // setcurrComAttrbs(arr);


    setcurrcombshow(arr);
    cmbString = cmbString.join("-");
    let foundCmb = false;
    for (const comb of product.combination) {
      if (comb.url && comb.active) {
        let s = comb.url;
        let aop = [];
        aop = s.split("_");
        if (aop[aop.length - 1] === cmbString) {
          // setCombPic(comb);
          setattrbs(comb.value);
          foundCmb = true;
          product.inActiveVarient = false;
          let isPres = false;
          let lop = 0;
          if (product.vendors && product.vendors[0] !== null) {
            for (let vurl of product?.vendors?.[0]?.combination) {
              if (vurl.url === comb.url) {
                // currIndex = lop;
                // history.replace({
                //   pathname: window.location.pathname,
                //   search: "?url=" + vurl.url,
                // });

                //change packages based on combination change
                let propPkgs = [];
                product.pkgs &&
                  product.pkgs.map((item1, index) => {
                    if (item1.url === vurl.url) {
                      // if (item1.lockStatus && !weightLocked) {
                      //   setWeightLocked(true);
                      // }
                      // sl - 712
                      // if (vurl?.sellerWeightChangeSts === "T_PENDING") {
                      //   api.product.getSellerWeightChangePendingReq({ "product": props.match.params.pId, "pkg.url": vurl.url }).then((res) => {
                      //     dispatch(setInitialPackages(packagesCmtoFt(res?.data?.pkgs)))
                      //   }).catch(err => {
                      //     console.log(err)
                      //   })
                      // }
                      // else {
                      //   dispatch(setInitialPackages(packagesCmtoFt(item1.pkgs)))
                      // }
                      // for (const pkg1 of item1.pkgs) {
                      //   if (pkg1.status === "APPROVED") {
                      //     pkg1["packageWidthFront"] = (pkg1.packageWidth / 30.48).toFixed(2);
                      //     pkg1["packageHeightFront"] = (pkg1.packageHeight / 30.48).toFixed(2);
                      //     pkg1["packageLengthFront"] = (pkg1.packageLength / 30.48).toFixed(2);
                      //     propPkgs.push(pkg1);
                      //     // break;
                      //   }
                      // }
                    }
                  });
                // setCurrPkgs(propPkgs);

                // if (
                //   vurl.purchase_price !== undefined &&
                //   vurl.purchase_price !== ""
                // ) {
                //   if (vurl.purchase_price > comb.lowestPrice) {
                //     setlowestPrice(comb.lowestPrice);
                //   } else {
                //     setlowestPrice(undefined);
                //   }

                isPres = true;
                // setcurrcombarr(vurl);
                console.log(vurl)
                setcurComurl(vurl.url)
                // if (product.vendors[0].prSts) {
                //   setpriceHistoryloaded(false);
                //   let vdata = {
                //     pageNo: 1,
                //     selectedId: props.match.params.pId,
                //     url: comburl,
                //   };
                //   api.product
                //     .vPriceReqRetrieveAll(transferPriceHistory(vdata))
                //     .then((res) => {
                //       setpriceHistoryloaded(true);
                //       if (res.data.length > 0) {
                //         currHistId = res.data[0]._id;
                //         setofferprice(res.data[0].price);
                //       }
                //       setvendToolHistArr(res.data);
                //     })
                //     .catch((err) => console.log(err));
                // }
                return;
                // } 
                // else {
                //   setcurrcombarr();
                // }
                break;
              } else {
                // setcurrcombarr();
              }
              lop++;
            }
          }
          if (!isPres) {
            // history.replace({
            //   pathname: window.location.pathname,
            //   search: "?url=" + comb.url,
            // });
            setcurComurl(comb.url)

            // setcurrcombarr("");
            // setlowestPrice(undefined);
            // setPriceReqType("newCombReq");
          }
        }
      }
    }

    if (!foundCmb) {
      product.inActiveVarient = true;
      // setcurrcombarr("");
      // setlowestPrice(undefined);
      alert.info("This combination is not available.");
    }

  }

  const styles = {
    combination: {
      ul: {
        padding: "0px"
      },
      attribName: {
        textAlign: "left"
      }
    }
  }

  useEffect(() => {

    if ((price < 1 || price.includes(".")) && price !== "") {
      setpriceToastMsg(" Please enter a valid price");
      settoastprice("block");
      setGrabOrderUpdate(false);
    } else if (price > props.expectedPriceTo) {
      setpriceToastMsg(` Price should be lower than ${props.expectedPriceTo}`);
      settoastprice("block");
      setGrabOrderUpdate(false);
    } else {
      setpriceToastMsg("");
      settoastprice("none");
      if (price > 0 || price !== "")
        setGrabOrderUpdate(true);
      else
        setGrabOrderUpdate(false);
    }
  }, [price]);

  function updateProduct() {
    console.log(props);
    settoastprice("none");
    setstockToast("none")
    if (props.from !== "chooseProduct") {

      if (props.from === "approved-Pro") {
        // For combination
        if (curComurl !== undefined) {
          if (
            price === undefined ||
            price === null ||
            price < 1 ||
            price.includes(".")
          ) {
            setpriceToastMsg(" Please enter a valid price");
            settoastprice("block");
          } else if (pkgsValidation > 0) {
            return false;
          } else {
            let data = {
              _id: props.lead,
              purchase_price: price,
              url: curComurl,
            };
            api.product
              .addToExProduct(data)
              .then((res) => {
                props.callbackResFun(res.message);
              })
              .catch((err) => console.log(err));
          }
        } else {
          if (
            price === undefined ||
            price === null ||
            price < 1 ||
            price.includes(".")
          ) {
            setpriceToastMsg(" Please enter a valid price");
            settoastprice("block");
          } else if (pkgsValidation > 0) {
            return false;
          } else {
            let data = {
              _id: props.lead,
              purchase_price: price,
            };
            api.product
              .addToExProduct(data)
              .then((res) => {
                props.callbackResFun(res.message);
              })
              .catch((err) => console.log(err));
          }
        }
      }
      else {

        if (quantity === "0") {
          let data = {
            _id: props.lead,
            vActive: "INACTIVE",

            stock: Number(quantity),
          };
          api.product
            .addToExProduct(data)
            .then((res) => {
              props.callbackResFun(res.message);
            })
            .catch((err) => console.log(err));
        } else {
          //<Start-Here> Margin Validation Ticket : I1-2203
          try {
            //console.log(props.detail)
            let mProductPrice = 0;
            if (props.detail?.product?.combination && props.detail?.product?.combination.length > 0) {
              const mSelectedCombination = props.detail.product.combination.filter((item) => item.SKU === props.detail?.SKU);
              if (mSelectedCombination?.length > 0) {
                //console.log(mSelectedCombination[0]);
                mProductPrice = mSelectedCombination[0]?.sPrice && mSelectedCombination[0]?.sPrice > 0
                  ? mSelectedCombination[0]?.sPrice
                  : mSelectedCombination[0]?.price;
              }
            }
            else {
              mProductPrice = props.detail.product.specialPrice && props.detail.product.specialPrice > 0
                ? props.detail.product.specialPrice
                : props.detail.product.price;
            }

            let mVendorMargin = 0;
            if (mProductPrice > 0) {
              mVendorMargin =
                ((mProductPrice - price) / mProductPrice) * 100;
            }
            //console.log(`Vendor Price ${price} Product Price ${mProductPrice} and Margin ${mVendorMargin}`)
            if (mVendorMargin < PRICE_MARGIN_PERCENTAGE) {
              setpriceToastMsg(" Requested price too high to maintain required margin.");
              settoastprice("block");
              return false;
            }
          } catch (error) {
            console.error(error);
          }
          //</End-Here> Margin Validation Ticket : I1-2203
          document.getElementById("sub_newreq").disabled = true;
          let data;
          if (props.detail.taxClass == gst) {

            data = {
              _id: props.lead,
              purchase_price: price,
            };
          } else {

            data = {
              _id: props.lead,
              purchase_price: price,
              taxClass: gst,
            };
          }
          //SL-660
          if (props.flag === "Grab Order") {
            data["status"] = "PENDING";
            data["_id"] = props.detail._id;
            data['receivedFrom'] = "grab_order";
            data['orderId'] = props.detail.orderId
            //SL-660 Attribute Case
            if (props.detail?.url) {
              const combination = {};
              combination['url'] = props.detail.url;
              combination['purchase_price'] = data["purchase_price"];
              data["combination"] = combination;
              delete data["purchase_price"];
              data["addCombinationFlag"] = true;
            }

          }
          else if (props.flag === "Product oppertunities") {
            // sl-758 (29/8/25)
            data["status"] = "PENDING";
            data["_id"] = props.detail._id;
            data['receivedFrom'] = "opportunities";
            data['orderId'] = props.detail.orderId
            //SL-660 Attribute Case
            if (props.detail?.url) {
              const combination = {};
              combination['url'] = props.detail.url;
              combination['purchase_price'] = data["purchase_price"];
              data["combination"] = combination;
              delete data["purchase_price"];
              data["addCombinationFlag"] = true;
            }
          }
          else if (props.flag === "TV Catalogue") {
            data['receivedFrom'] = "tv_catalog";

          }

          if (!pkgChanged && pkgs.length > 0) {

            data["sellerWeightSts"] = "V_ACTIVE";
          }

          // add seller pkgs
          let pkgData;
          if (pkgChanged) {

            pkgData = {
              product: props.lead,
              status: "T_PENDING",
              pkg: { productName: props.productName, pkgs },
              categories: props.detail.categories,
              requestType: "NEW_PRODUCT"
            };
          }

          api.product
            .addToExProduct(data)
            .then((res) => {
              props.callbackResFun(res.message);

              // add seller pkgs
              if (
                (res.message == "product updated" ||
                  res.message == "product added") &&
                pkgChanged
              ) {
                const sanitizedPkgData = sanitizePkgImages(pkgData);
                api.product
                  .saveSellerWeightChangeReq(sanitizedPkgData)
                  .then((res) => {

                  })
                  .catch((err) => console.log(err));
              }
              if (document.getElementById("sub_newreq") != null)//I1-2203
                document.getElementById("sub_newreq").disabled = false;
            })
            .catch((err) => console.log(err));
        }
      }
    } else {
      if (
        price === undefined ||
        price === "" ||
        price === "0" ||
        price === 0 ||
        price < 1 ||
        price.includes(".")
      ) {
        setpriceToastMsg(" Please enter a valid price");
        settoastprice("block");
      }
      else if ((quantity === undefined ||
        quantity === "" ||
        quantity === "0" ||
        quantity === 0 ||
        quantity < 1 ||
        quantity.includes(".")) && props.flag !== "Grab Order") {
        console.log("sf called");
        setstockToastMsg(" Please enter a valid stock value.");
        setstockToast("block");
        return false;
      }
      else if (pkgsValidation > 0) {
        console.log("sdf called");
        return false;
      } else {

        document.getElementById("sub_newreq").disabled = true;
        let data;
        if (props.detail.taxClass == gst) {

          data = {
            _id: props.lead,
            purchase_price: price,
          };
        } else {

          data = {
            _id: props.lead,
            purchase_price: price,
            taxClass: gst,
          };
        }
        //SL-660
        if (props.flag === "Grab Order") {
          data["status"] = "PENDING";
          data["_id"] = props.detail._id;
          data['receivedFrom'] = "grab_order";
          data['orderId'] = props.detail.orderId
          //SL-660 Attribute Case
          if (props.detail?.url) {
            const combination = {};
            combination['url'] = props.detail.url;
            combination['purchase_price'] = data["purchase_price"];
            data["combination"] = combination;
            delete data["purchase_price"];
            data["addCombinationFlag"] = true;
          }


        }
        else if (props.flag === "Product oppertunities") {
          data["_id"] = props.detail._id;
          data['receivedFrom'] = "opportunities";
          data['orderId'] = props.detail.orderId
          //SL-660 Attribute Case
          if (props.detail?.url) {
            const combination = {};
            combination['url'] = props.detail.url;
            combination['purchase_price'] = data["purchase_price"];
            data["combination"] = combination;
            delete data["purchase_price"];
            data["addCombinationFlag"] = true;
          }
        }
        else if (props.flag === "TV Catalogue") {
          data['receivedFrom'] = "tv_catalog";

        }

        data["stock"] = Number(quantity);

        // add seller pkgs
        let pkgData;

        if (props?.detail?.attributeList?.length > 0) {
          pkgData = {
            product: props.lead,
            status: "T_PENDING",
            pkg: { url: curComurl, pkgs: packagesFttoCm(packages) },
            categories: props.detail.categories,
            requestType: "NEW_PRODUCT"
          };
          const combination = {};
          combination['url'] = curComurl
          combination['purchase_price'] = price
          data["combination"] = combination;
          delete data["purchase_price"];
        }
        else {
          pkgData = {
            product: props.lead,
            status: "T_PENDING",
            pkg: { productName: props.productName, pkgs: packagesFttoCm(packages) },
            categories: props.detail.categories,
            requestType: "NEW_PRODUCT"
          };
        }

        api.product
          .addToExProduct(data)
          .then((res) => {
            props.callbackResFun(res.message);
            document.getElementById("sub_newreq").disabled = false;
          })
          .catch((err) => console.log(err));
      }
    }

  }
  // Add new combination from product detail page

  function newCombadd() {
    if (
      price < 1 ||
      price === undefined ||
      price === "" ||
      price.includes(".")
    ) {
      props.addComb("price_und", curComurl);
    } else {
      props.addComb(price, curComurl);
    }
  }

  const handleClose = () => {
    console.log("closing")
    dispatch(resetPackages())
    setcurComurl(undefined)
    props.Popupvisibilityfun(false);
  };

  const changeGST = (e) => {

    setGst(e.value);
  };

  // sl - 712
  const handleSubmitPackages = (packages) => {
    SetCataloguePage(2)
  }

  const confirmProceed = () => {
    if (props.detail.attributeList && props.detail.attributeList.length > 0) {
      if (curComurl === undefined) {
        alert.info("Please select a valid combination.")
        return
      }
    }
    SetCataloguePage(2)
  }

  // if from product detail page
  if (props.from === "appPro_detail") {
    return (
      <div className="oM-c d-flex row align-items-center pop_cntn">
        <div className="col popup popup-q combo-popup popup-combination mx-auto">
          <a
            className="close mt-2"
            onClick={() => {
              props.checkVariant(props.firstcomburl, props.firstPrice);
              props.Popupvisibilityfun(false);
            }}
          >
            &times;
          </a>

          <Row className=" ">
            <div className="col-3 ">
              <img

                src={"https://s3.toolsvilla.com/" + props.img}
                className="full-width ms-15"
              ></img>
            </div>
            <div className="col-9">
              <p className="product-name ff_pop">
                {props.productName}(
                {currcombshow &&
                  currcombshow.map((item, index) => {
                    if (currcombshow.length - 1 === index) {
                      return (
                        <>
                          <span>{item}</span>
                        </>
                      );
                    } else {
                      return (
                        <>
                          <span>{item},</span>
                        </>
                      );
                    }
                  })}
                )
              </p>
              <p className="sku">{props.detail.SKU}</p>
              <h6 className="pd_pName">{props?.manufacturerName}</h6>
              <p className="transfer-price ff_pop">
                Transfer Price(incl. {props.detail.taxClass} % GST) :
                <span className="text-dark">
                  <i className="fa fa-inr"></i> {price}
                </span>
                {props.currcombarr &&
                  props.currcombarr.prSts &&
                  props.vendToolHistArr.length > 0 ? (
                  <i
                    className="fa fa-info-circle text-red mx-2"
                    onClick={() => props.handleopenoffcanpriceHist()}
                  ></i>
                ) : (
                  <></>
                )}
              </p>
              {props.combstatus !== undefined ? (
                props.combstatus === "ACTIVE" ? (
                  <>
                    <div>
                      <div class="form-check form-switch p-0">
                        <BootstrapSwitchButton
                          onChange={() => props.changeToggle(props.lead)}
                          checked={check}
                          onlabel="In stock"
                          offlabel="Out of Stock"
                          onstyle="success"
                          offstyle="danger"
                          size="sm"
                          width="100"
                        />
                      </div>
                    </div>
                  </>
                ) : props.combstatus === "INACTIVE" ? (
                  <>
                    <div>
                      <div class="form-check form-switch p-0">
                        <BootstrapSwitchButton
                          onChange={() =>
                            props.changeinActivetoggle(props.lead)
                          }
                          checked={inActiveCheck}
                          onlabel="In stock"
                          offlabel="Out of stock"
                          onstyle="success"
                          offstyle="danger"
                          size="sm"
                          width="100"
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <div class="form-check form-switch p-0">
                        <BootstrapSwitchButton
                          onChange={() => props.handleToast()}
                          checked={check}
                          onlabel="In stock"
                          // disabled={true}
                          offlabel="Out of stock"
                          onstyle="success"
                          offstyle="danger"
                          size="sm"
                          width="100"
                        />
                      </div>
                      {/* <div className="in-pend-app">
                                        <span className="fs-12">Inactive request pending for approval</span>
                                      </div> */}
                    </div>
                  </>
                )
              ) : (
                <></>
              )}
              {props.currcombarr && props.currcombarr.purchase_price ? (
                props.currcombarr.purchase_price > props.lowestPrice ? (
                  <p className=" pt-2 pb-0 f-600 fs-10">
                    <span className="text-warning fs-11">
                      <i className="bi bi-exclamation-triangle-fill"></i>
                    </span>
                    <span className="other_seller_price">
                      {" "}
                      Other seller's price(incl. GST) :
                    </span>
                    <span className="f-600 fs-13 ms-1 mt-1 text-primary">
                      {" "}
                      <i className="fa fa-inr"></i> {props.lowestPrice}{" "}
                    </span>
                  </p>
                ) : (
                  <></>
                )
              ) : (
                <></>
              )}
              {props.currcombarr &&
                props.currcombarr.vActive === "INACTIVE_REQ" ? (
                <p className="inactiveReq fs-10 text-center m-1">
                  Inactive request pending for Toolsvilla approval
                </p>
              ) : (
                <></>
              )}
            </div>
          </Row>

          {props.combattr.map((item, index) => {
            return (
              <>
                <Row>
                  <div className="col-12">
                    <p className="fs-14 f-600 px-3 pb-2 mb-0">
                      {item.attribute.name}
                    </p>
                  </div>
                </Row>
                <ul className="l-n d-flex over-flow pb-2 mb-3">
                  {item.values.map((acom, indexx) => {
                    if (
                      selValscombrow[index] === index &&
                      selValscombcol[index] === indexx
                    ) {
                      return (
                        <>
                          <li class="mx-1 mb-0">
                            {" "}
                            <button
                              id={"combind" + index + "es" + indexx}
                              className={"combactive shed combgrp" + index}
                              onClick={() => {
                                item.selectedValue = acom;
                                checkVariant(
                                  props.product,
                                  index,
                                  indexx,
                                  item,
                                  acom
                                );
                              }}
                            >
                              {acom}
                            </button>
                          </li>
                        </>
                      );
                    } else {
                      return (
                        <>
                          <li class="mx-1 mb-0">
                            {" "}
                            <button
                              id={"combind" + index + "es" + indexx}
                              className={"shed combgrp" + index}
                              onClick={() => {
                                item.selectedValue = acom;
                                checkVariant(
                                  props.product,
                                  index,
                                  indexx,
                                  item,
                                  acom
                                );
                              }}
                            >
                              {acom}
                            </button>
                          </li>
                        </>
                      );
                    }
                  })}
                </ul>
              </>
            );
          })}

          {isCombPresent === true ? (
            <>
              {" "}
              <Row className="text-center mt-1 mx-5 pl-1"></Row>
            </>
          ) : (
            <>
              <h6>Not present</h6>
            </>
          )}
          {props.from === "appPro_detail" ? (
            props.currcombarr && props.currcombarr.purchase_price ? (
              props.currcombarr && !props.currcombarr.prSts ? (
                <button
                  className="v-t-f"
                  onClick={() => props.handleverifyoffcan()}
                >
                  Verify transfer price
                </button>
              ) : props.currcombarr.prSts === "V_ACTIVE" ||
                props.currcombarr.prSts === "V_REJECT" ||
                props.currcombarr.prSts === "T_ACTIVE" ||
                props.currcombarr.prSts === "T_REJECT" ? (
                <button
                  className="r-t-f"
                  onClick={() => props.handleopenoffcan()}
                >
                  Request new Transfer Price
                </button>
              ) : (
                <></>
              )
            ) : (
              <></>
            )
          ) : (
            <></>
          )}

          {/* To add combinations */}
          {props.vendorfirstComb &&
            props.vendorfirstComb.length > 0 &&
            props.currcombarr === "" &&
            isCombPresent ? (
            <>
              <form className="fs-13">
                <label className="d-flex mt-2">
                  <span className="me-1 transfer-price ff_pop">
                    Transfer Price (incl GST) for
                  </span>{" "}
                  {currcombshow &&
                    currcombshow.map((item, index) => {
                      if (currcombshow.length - 1 === index) {
                        return (
                          <>
                            <span className=" text-primary">{item}</span>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <span className="text-primary">{item}</span>
                            <span className="fs-12 mx-1"> x </span>
                          </>
                        );
                      }
                    })}
                  :
                  <input
                    type="number"
                    name="number"
                    autoComplete="off"
                    minLength="1"
                    onKeyDown={checkMinusInput}
                    required
                    onChange={(e) => setPrice(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                    className="in-box m pad_l1"
                  />
                </label>
              </form>
              <Button size="sm" variant="info" onClick={() => newCombadd()}>
                Add combination
              </Button>
            </>
          ) : (
            <></>
          )}

          {props.currcombarr &&
            props.currcombarr.prSts &&
            props.currcombarr.prSts === "T_PENDING" ? (
            <>
              <span className="inactiveReq fs-12 f-600 text-danger">
                Your requested price : Rs.{" "}
                {props.vendToolHistArr &&
                  props.vendToolHistArr.length > 0 &&
                  props.vendToolHistArr[0].price}{" "}
                &lt;pending for verification from Toolsvilla &gt;
              </span>
              <br></br>
            </>
          ) : (
            <></>
          )}

          {props.currcombarr &&
            props.currcombarr.prSts &&
            props.currcombarr.prSts === "T_PENDING" &&
            props.currcombarr.vActive !== "INACTIVE" ? (
            <span className=" fs-10 f-400">
              You agree to keep selling at the present price until the transfer
              price is confirmed.{" "}
            </span>
          ) : (
            <></>
          )}
          <br></br>

          {props.currcombarr &&
            props.currcombarr.prSts === "V_PENDING" &&
            props.vendToolHistArr.length > 0 ? (
            <>
              <div className="acc_rej_cntn">
                <div className="col-12 fs-12 my-2">
                  New Transfer Price request from Toolsvilla :{" "}
                  <span>
                    <span className="f-600 fs-15">
                      {" "}
                      <i className="fa fa-inr"></i>
                      {props.offerprice}
                    </span>
                    <br></br>
                    <span className="fs-12 f-600">
                      {" "}
                      Do you Want to accept it ?
                    </span>
                  </span>
                </div>
                <Row className="text-center my-3">
                  <div className="col-6 pt-1">
                    <button
                      className="no-button"
                      onClick={() => props.priceReqfromTool("reject")}
                    >
                      No
                    </button>
                  </div>
                  <div className="col-6 pt-1">
                    <button
                      className="yes-button"
                      onClick={() => props.priceReqfromTool("accept")}
                    >
                      yes
                    </button>
                  </div>
                </Row>
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
  // if combination
  else if (props.combattr) {

    return (
      <div className="oM-c pop_cntn">
        <div class=" popup popup-q combo-popup popup-combination ex1">
          <a
            className="close mt-2"
            onClick={() => props.Popupvisibilityfun(false)}
          >
            &times;
          </a>

          <Row className=" ">
            <div className="col-4 ">
              <img
                src={"https://s3.toolsvilla.com/" + props.img}
                className="full-width ms-15"
              ></img>
            </div>
            <div className="col-9">
              <p className="product-name ff_pop">
                {props.productName}(
                {currcombshow &&
                  currcombshow.map((item, index) => {
                    if (currcombshow.length - 1 === index) {
                      return (
                        <>
                          <span>{item}</span>
                        </>
                      );
                    } else {
                      return (
                        <>
                          <span>{item},</span>
                        </>
                      );
                    }
                  })}
                )
              </p>
              <p className="sku">{props.detail.SKU}</p>
              {props.from === "chooseProduct" ? (
                <></>
              ) : (
                <p className="transfer-price ff_pop">
                  Transfer Price(incl. GST) :
                  <span className="text-dark">
                    <i className="fa fa-inr"></i>
                    {price}/unit
                  </span>
                </p>
              )}
            </div>
          </Row>
          {props.combattr.map((item, index) => {

            return (
              <>
                <Row>
                  <div className="col-12">
                    <p className="fs-14 f-600 px-3 pb-2 mb-0">
                      {item.attribute.name}
                    </p>
                  </div>
                </Row>
                <ul className="l-n d-flex over-flow pb-2 mb-3">
                  {item.values.map((acom, indexx) => {
                    return (
                      <>
                        {/* <div className="col-4"><button  className="shed " onClick={() => {item.selectedValue = acom;checkVariant(props.product)}}>{acom}</button></div>
                                                </> */}
                        <li class="mx-1 mb-0">
                          {" "}
                          <button
                            id={"combind" + index + "es" + indexx}
                            className={"shed combgrp" + index}
                            onClick={() => {
                              item.selectedValue = acom;
                              checkVariant(props.product, index, indexx);
                            }}
                          >
                            {acom}
                          </button>
                        </li>
                      </>
                    );
                  })}
                </ul>
              </>
            );
          })}

          {isCombPresent === true ? (
            <>
              {" "}
              <Row className="text-center mt-1 mx-5 pl-1">
                {/* <div className="col-12">
                            <form className="fs-10">
                               
                                <span className="toastAlert" style={{ "display": toastprice }}><i class="fa fa-exclamation" aria-hidden="true"></i>{priceToastMsg}.</span>
                                <label className="d-flex mt-2">
                                Transfer Price to Toolsvilla(incl. gst):
                                    <input type="number" value={price} name="number" onKeyDown={checkMinusInput}  onChange={(e) => setPrice(e.target.value)} onWheel={(e) => e.target.blur()} className="in-box m pad_l1" />
                                </label>

                            </form>
                        </div> */}
              </Row>
              {/* 
                        <Row className="my-3">

                            <div className="col-12 fs-14 py-2"><button className="bg-theme text-white w-100 b-n py-2 corner" onClick={() => updateProduct()}>UPDATE</button></div>
                        </Row> */}
            </>
          ) : (
            <>
              <h6>Not present</h6>
            </>
          )}
          {props.from === "appPro_detail" ? (
            props.currcombarr && props.currcombarr.purchase_price ? (
              props.currcombarr && !props.currcombarr.prSts ? (
                <Button
                  size="sm"
                  variant="info"
                  onClick={() => props.handleverifyoffcan()}
                >
                  Verify transfer price
                </Button>
              ) : props.currcombarr.prSts === "V_ACTIVE" ||
                props.currcombarr.prSts === "V_REJECT" ||
                props.currcombarr.prSts === "T_ACTIVE" ||
                props.currcombarr.prSts === "T_REJECT" ? (
                <Button
                  size="sm"
                  variant="info"
                  onClick={() => props.handleopenoffcan()}
                >
                  Request new Transfer Price
                </Button>
              ) : (
                <></>
              )
            ) : (
              <></>
            )
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
  else {
    const ModalHeader = ({ img }) => {
      return (
        <>
          <div className="col-md-4 " style={{ alignSelf: 'baseline', marginTop: "10px" }}>
            <div
              className="catalog-img-border"
              style={{
                background: `url(
                "https://s3.toolsvilla.com/${img}"
              )` }}
            >
            </div>
          </div>
          <div className="col-md-8 align-self-start mt-2">
            <p className="product-name ff_pop fw-bold d-flex justify-contain-start">{props.productName}</p>
            <p className="sku mb-2 d-flex justify-contain-start">SKU - {props.detail.SKU}</p>
            {/* <h6 className="product-name ff_pop fw-bold d-flex justify-contain-start">Brand Name</h6> */}

            {props.from === "chooseProduct" ? (
              props.lowestPrice !== 0 &&
                props.lowestPrice !== undefined &&
                props.lowestPrice !== "" ? (
                <p className="other_seller_price d-flex justify-contain-start">

                  <span> Other seller's price (incl. GST) :</span>
                  <span>
                    {" "}
                    <i className="fa fa-inr"></i> {props.lowestPrice}{" "}
                  </span>
                </p>
              ) : (
                <></>
              )
            ) : (
              <p className="transfer-price ff_pop">
                Transfer Price (incl. {props.detail.taxClass}% GST) :{" "}
                <span className="text-dark">
                  <i className="fa fa-inr"></i>
                  {props.detail.price}/unit
                </span>
              </p>
            )}
            {
              cataloguePage === 0 ? <div style={{ textAlign: 'left' }}><p className="fs-13">Description</p>
                <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: props.detail.shortDescription }}></div>
                <div style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: props.detail.product?.description }}></div>
              </div> : <></>
            }
            {props.detail.attributeList &&
              props.detail.attributeList.map((item, index) => {
                return (
                  <>
                    <Row>
                      <div className="col-12">
                        <p className="fs-14 f-600 pb-2 mb-0" style={styles.combination.attribName}>
                          {item.attribute.name}
                        </p>
                      </div>
                    </Row>
                    <ul className="l-n d-flex overflow-auto pb-2 mb-3 w-90" style={styles.combination.ul}>
                      {item.values.map((acom, indexx) => {
                        let isAttrb = false;
                        attrbs &&
                          attrbs.length > 0 &&
                          attrbs.map((attr, aIndex) => {
                            if (acom === attr) {
                              isAttrb = true;
                            }
                          });
                        if (isAttrb === true) {
                          return (
                            <>
                              <li class="mx-1 mb-0">
                                {" "}
                                <button
                                  id={"combind" + index + "es" + indexx}
                                  className={"combactive shed combgrp" + index}
                                  onClick={() => {
                                    item.selectedValue = acom;
                                    checkVariant(index, indexx);
                                  }}
                                >
                                  {acom}
                                </button>
                              </li>
                            </>
                          );
                        } else {
                          return (
                            <>
                              <li class="mx-1 mb-0">
                                {" "}
                                <button
                                  id={"combind" + index + "es" + indexx}
                                  className={"shed combgrp" + index}
                                  onClick={() => {
                                    item.selectedValue = acom;
                                    checkVariant(index, indexx);
                                  }}
                                >
                                  {acom}
                                </button>
                              </li>
                            </>
                          );
                        }
                      })}
                    </ul>
                  </>
                );
              })}
          </div>
        </>
      )
    }

    // SL-901
    const confirmPricePopupStyles = {
      appContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f3f4f6',
        padding: '1rem',
        fontFamily: 'sans-serif',
      },
      cardWrapper: {
        backgroundColor: '#ffffff',
        borderRadius: '1rem',
        boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
        width: '100%',
        maxWidth: '28rem', // Adjusted max-width for this card
        overflow: 'hidden',
        border: '1px solid #e5e7eb',
      },
      cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '1.5rem',
        backgroundColor: '#f9fafb',
        borderBottom: '1px solid #e5e7eb',
      },
      cardTitle: {
        fontSize: '1.25rem',
        fontWeight: 700,
        color: '#1f2937',
      },
      closeButton: {
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: '#9ca3af',
        fontSize: '1.5rem',
        padding: 0,
      },
      mainContent: {
        padding: '1.5rem',
      },
      productDetails: {
        display: 'flex',
        alignItems: 'center',
        gap: '1rem',
        marginBottom: '1.5rem',
      },
      productImage: {
        borderRadius: '0.5rem',
        width: '4rem',
        height: '4rem',
        objectFit: 'cover',
        flexShrink: 0,
      },
      productText: {
        flexGrow: 1,
      },
      productTitle: {
        fontSize: '1rem',
        fontWeight: 600,
        color: '#1f2937',
      },
      productSku: {
        fontSize: '0.75rem',
        color: '#6b7280',
        marginTop: '0.25rem',
      },
      priceContainer: {
        display: 'flex',
        gap: '0.5rem',
        marginTop: '0.5rem',
      },
      basePrice: {
        fontSize: '0.875rem',
        fontWeight: 600,
        color: '#6d28d9',
      },
      gst: {
        fontSize: '0.875rem',
        color: '#ef4444',
      },
      sectionTitle: {
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        fontSize: '1rem',
        fontWeight: 600,
        color: '#6d28d9',
        marginTop: '1.5rem',
        marginBottom: '0.75rem',
      },
      formGroup: {
        marginBottom: '1.5rem',
      },
      inputLabel: {
        display: 'block',
        fontSize: '12px',
        fontWeight: 600,
        color: '#374151',
        marginBottom: '0.5rem',
      },
      textInput: {
      },
      selectInput: {
        width: '100%',
        padding: '0.75rem 1rem',
        border: '1px solid #d1d5db',
        borderRadius: '0.5rem',
        fontSize: '1rem',
        backgroundColor: '#f9fafb',
        boxSizing: 'border-box',
        appearance: 'none', // Remove default dropdown arrow
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='currentColor'%3E%3Cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 1rem center',
        backgroundSize: '1.5em',
      },
      cardFooter: {
        display: 'flex',
        justifyContent: 'center',
        gap: '1rem',
        padding: '1.5rem',
        backgroundColor: '#f9fafb',
        borderTop: '1px solid #e5e7eb',
      },
      buttonBase: {
        padding: '0.75rem 2rem',
        borderRadius: '0.75rem',
        fontWeight: 600,
        cursor: 'pointer',
        border: 'none',
        transition: 'background-color 0.2s ease-in-out',
        flex: 1, // Make buttons take equal width
      },
      backButton: {
        backgroundColor: '#e5e7eb',
        color: '#4b5563',
      },
      submitButton: {
        backgroundColor: '#10b981',
        color: '#ffffff',
      },
    };
    // SL-901 eoc
    return (
      props?.flag === "Product oppertunities" ?
        <Modal
          show={true}
          onHide={handleClose}
          className="updtProPopModal"
          centered
        >
          <Modal.Body className="updtProPopModal_body p_3px">
            <a class="close mt-1" onClick={() => {
              handleClose()
              props.Popupvisibilityfun(false)
            }}>
              &times;
            </a>
            <Row className="">
              <div className="col-md-3 ">
                <div
                  className="catalog-img-border"
                  style={{
                    background: `url(
                "https://s3.toolsvilla.com/${props.img}"
              )`,
                  }}
                >
                  {/* <img

              src={"https://s3.toolsvilla.com/" + props.img}
              className="full-width ms-15"
            ></img> */}
                </div>
              </div>
              <div className="col-md-9">
                <p className="product-name ff_pop">{props.productName}</p>
                <p className="sku">{props.detail.SKU}</p>
                {props.from === "chooseProduct" ? (
                  props.lowestPrice !== 0 &&
                    props.lowestPrice !== undefined &&
                    props.lowestPrice !== "" ? (
                    <p className=" other_seller_price">
                      {/* <span className="text-warning fs-10">
                  <i className="bi bi-exclamation-triangle-fill"></i>
                </span> */}
                      <span> Other seller's price (incl. GST) :</span>
                      <span>
                        {" "}
                        <i className="fa fa-inr"></i> {props.lowestPrice}{" "}
                      </span>
                    </p>
                  ) : (
                    <></>
                  )
                ) : (
                  <p className="transfer-price ff_pop">
                    Transfer Price (incl. {props.detail.taxClass}% GST) :{" "}
                    <span className="text-dark">
                      <i className="fa fa-inr"></i>
                      {props.detail.price}/unit
                    </span>
                  </p>
                )}
                <Row className="text-center mt-1">
                  <div className="col-12 ">
                    <form className="">
                      <label className="transfer-price-container">
                        <span className="transfer-price ff_pop my-auto">
                          Transfer Price (incl. {gst}% GST) :
                        </span>
                        <span className="position-relative">
                          <input
                            type="number"
                            name="number"
                            autoComplete="off"
                            minLength="1"
                            onKeyDown={checkMinusInput}
                            required
                            onChange={(e) => setPrice(e.target.value)}
                            onWheel={(e) => e.target.blur()}
                            className="ms-1 w-100 input-with-label"
                          />
                          <span class="rs-label">Rs</span>
                          <span
                            className="toastAlert"
                            style={{ display: toastprice }}
                          >
                            <i class="fa fa-exclamation" aria-hidden="true"></i>
                            {priceToastMsg}.
                          </span>
                        </span>
                      </label>
                      <label className="gst-price-container">
                        <p className="title-100">Select GST % : </p>
                        <p className="gst-select">
                          <Form.Select
                            size="sm"
                            className="pro_card_comb_box_invent"
                            value={gst}
                            onChange={(e) => changeGST(e.target)}
                          >
                            {variables?.variables?.gstValues.map((item, index) => {
                              return (
                                <option key={index} value={item}>
                                  {item}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </p>
                      </label>
                    </form>
                  </div>
                </Row>
              </div>
            </Row>

            {/* product weight */}
            {pkgs && pkgs.length > 0 ? (
              <Row className="me-0  pkgCntWrap">
                <div className="">
                  <p>No of package</p>
                </div>
                <div>
                  <input
                    type="text"
                    value={pkgs.length}
                    className="pkgCnt text-center"
                    disabled
                  />
                </div>
                <div>
                  <p>(This product comes in {pkgs.length} package)</p>
                </div>
              </Row>
            ) : (
              <></>
            )}

            <Row className="me-0 my-2 ">
              {weightLocked && (
                <div className="col-12">
                  <p className="btmWeightConfirm">
                    {" "}
                    <input
                      type="checkbox"
                      id="weightCheck"
                      checked={confirmLockedWeight}
                      name="weightCheck"
                      // value="Select All"
                      className="mt-2 wCheckbx"
                      onChange={() => setConfirmLockedWeight(!confirmLockedWeight)}
                    />
                    <span>Please confirm the weight details else add a new product here : <a href="http://dseller.toolsvilla.in/form" className="wlink">Add new</a> </span>
                  </p>
                </div>
              )}
              {pkgs && pkgs.length > 0 ? (
                <div className="col-12">
                  <p className="btmNote">
                    {" "}
                    Note - All the shipments are checked at our courier warehouse
                    and if in case the product weight & dimensions are found
                    different than that given by the logistics company Toolsvilla
                    would debit the seller for the difference. We therefore
                    request you to be careful when entering the weight &
                    dimensions. Thank you!
                  </p>
                </div>
              ) : (
                <></>
              )}

              <div className="col-12 fs-14 text-center mt-5">
                {!weightLocked && (
                  <button
                    className="bg-theme text-white w-80 b-n py-1 corner mb-2 update-but"
                    id="sub_newreq"
                    onClick={() => updateProduct()}
                  >
                    Submit
                  </button>)}
                {weightLocked && confirmLockedWeight && (
                  <button
                    className="bg-theme text-white w-80 b-n py-1 corner mb-2 update-but"
                    id="sub_newreq"
                    onClick={() => updateProduct()}
                  >
                    Submit
                  </button>)}
              </div>
            </Row>
          </Modal.Body>
        </Modal>
        :
        props.flag === "Grab Order" ? // for grab order
          <Modal
            show={true}
            onHide={handleClose}
            className="updtProPopModal"
            centered
          >
            <Modal.Body className="updtProPopModal_body p_3px">
              <a class="close mt-1" onClick={() => {
                handleClose()
                props.Popupvisibilityfun(false)
              }}>

                &times;
              </a>
              {cataloguePage === 0 ?
                //Confirm Product Details
                <Row>
                  <div className="fw-bold d-flex justify-contain-start mt-2">STEP 1 : Confirm Product Details</div>
                  <div className="updtpropopup-custom-container">
                    <div className="col-md-3 align-self-start">
                      <div
                        className="catalog-img-border"
                        style={{
                          background: `url(
                    "https://s3.toolsvilla.com/${props.img}"
                  )`,
                        }}
                      >
                      </div>
                    </div>
                    <div className="col-md-9 align-self-start mt-2">
                      <p className="product-name ff_pop fw-bold d-flex justify-contain-start">{props.productName}</p>
                      <p className="sku mb-2 d-flex justify-contain-start">{props.detail.SKU}</p>
                      <p className="product-name ff_pop d-flex justify-contain-start fw-bold">{props.brandName}</p>
                      <p className="sku mb-2 d-flex justify-contain-start fw-bold">Description : </p>

                      {props?.detail?.description ?
                        <div
                          dangerouslySetInnerHTML={{
                            __html: props?.detail?.description

                          }}
                          className="description-content"
                          style={{ textAlign: "left" }}
                        />
                        :
                        <span className="sku d-flex justify-content-center ms-2">No Description Found</span>
                      }

                    </div>
                  </div>
                  <div className="d-flex justify-content-end d-flex-responsive">
                    <button
                      className="bg-theme text-white b-n corner update-but-catalogue"
                      id="sub_newreq"
                      onClick={() => {
                        SetCataloguePage(pkgs.length > 0 ? 1 : 2)
                      }}
                    >
                      Confirm and Proceed
                    </button>
                  </div>
                </Row> : cataloguePage === 1 ?

                  <Row>
                    <div className="fw-bold mt-2 d-flex justify-contain-start">STEP 2 : Confirm Package Details</div>
                    <div className="updtpropopup-custom-container">
                      <div className="row">
                        <div className="col-md-3 align-self-start">
                          <div
                            className="catalog-img-border"
                            style={{
                              background: `url(
                    "https://s3.toolsvilla.com/${props.img}"
                  )`,
                            }}
                          >
                            {/* <img
                  src={"https://s3.toolsvilla.com/" + props.img}
                  className="full-width ms-15"
                ></img> */}
                          </div>
                        </div>
                        <div className="col-md-9 align-self-start">
                          <p className="product-name ff_pop fw-bold d-flex justify-contain-start">{props.productName}</p>
                        </div>
                      </div>
                    </div>
                    <WeightComponent viewOnly={true} />

                    <div className="d-flex justify-content-end">
                      <button
                        className="me-3 text-white w-30 bg-secondary cursor-pointer responsive-btn back-updt-popup"
                        onClick={() => SetCataloguePage(0)}
                      >
                        Back
                      </button>
                      <button
                        className="bg-theme text-white w-100 b-n corner update-but-catalogue"
                        id="sub_newreq"
                        onClick={() => SetCataloguePage(2)}
                      >
                        Confirm and Proceed
                      </button>
                    </div>
                  </Row>
                  : cataloguePage === 2 ?
                    //Confirm Price
                    <Row className="">
                      <div className="fw-bold mt-2 d-flex justify-contain-start">STEP {pkgs.length > 0 ? "3" : "2"} : Confirm Price</div>
                      <div className="col-md-3 align-self-start">
                        <div
                          className="catalog-img-border"
                          style={{
                            background: `url(
                    "https://s3.toolsvilla.com/${props.img}"
                  )`,
                          }}
                        >
                          {/* <img

                  src={"https://s3.toolsvilla.com/" + props.img}
                  className="full-width ms-15"
                ></img> */}
                        </div>

                      </div>
                      <div className="col-md-9 align-self-start">
                        <p className="product-name ff_pop fw-bold d-flex justify-contain-start">{props.productName}</p>
                        <p className="sku mb-2 d-flex justify-contain-start">{props?.detail?.SKU}</p>
                        {props.expectedPriceFrom && props.expectedPriceTo &&
                          <p className="transfer-price ff_pop text-danger" style={{ textAlign: "left", fontWeight: "bold", fontSize: "14px" }}>

                            Expected Transfer Price :{" "}
                            <span className="" style={{ fontSize: "14px" }}>
                              <i className="fa fa-inr"></i>{props.expectedPriceFrom}&nbsp;
                              -
                              &nbsp;<i class="fa fa-inr" aria-hidden="true"></i>{props.expectedPriceTo}
                            </span>
                          </p>
                        }
                        {props.from === "chooseProduct" ? (
                          props.lowestPrice !== 0 &&
                            props.lowestPrice !== undefined &&
                            props.lowestPrice !== "" ? (
                            <p className="other_seller_price d-flex justify-contain-start">

                              <span> Other seller's price (incl. GST) :</span>
                              <span>
                                {" "}
                                <i className="fa fa-inr"></i> {props.lowestPrice}{" "}
                              </span>
                            </p>
                          ) : (
                            <></>
                          )
                        ) : (
                          <p className="transfer-price ff_pop">
                            Transfer Price (incl. {props.detail.taxClass}% GST) :{" "}
                            <span className="text-dark">
                              <i className="fa fa-inr"></i>
                              {props.detail.price}/unit
                            </span>
                          </p>
                        )}
                        <Row className="text-center mt-1">
                          <div className="col-12 ">
                            <form className="">
                              <label className="transfer-price-container">
                                <span className="transfer-price ff_pop my-auto">
                                  Transfer Price (incl. {gst}% GST) :
                                </span>
                                <span className="position-relative" style={{ width: "100%" }}>
                                  <input
                                    type="number"
                                    name="number"
                                    autoComplete="off"
                                    minLength="1"
                                    onKeyDown={checkMinusInput}
                                    required
                                    onChange={(e) => setPrice(e.target.value)}
                                    onWheel={(e) => e.target.blur()}
                                    className="ms-1 w-100 input-with-label"
                                  />
                                  <span class="rs-label">Rs</span>
                                  <span
                                    className="toastAlert"
                                    style={{ display: toastprice }}
                                  >
                                    <i class="fa fa-exclamation" aria-hidden="true"></i>
                                    {priceToastMsg}.
                                  </span>
                                </span>
                              </label>
                              <label className="gst-price-container">
                                <p className="title-100" style={{ fontSize: "13px" }}>Select GST % : </p>
                                <p className="gst-select">
                                  <Form.Select
                                    size="sm"
                                    className="pro_card_comb_box_invent"
                                    value={gst}
                                    onChange={(e) => changeGST(e.target)}
                                  >
                                    {variables?.variables?.gstValues.map((item, index) => {
                                      return (
                                        <option key={index} value={item}>
                                          {item}
                                        </option>
                                      );
                                    })}
                                  </Form.Select>
                                </p>
                              </label>
                            </form>
                          </div>
                        </Row>
                      </div>
                      <div className="d-flex justify-content-end">
                        <button
                          className="me-3 text-white w-20 bg-secondary cursor-pointer responsive-btn back-updt-popup update-but-catalogue"
                          onClick={() => {
                            if (pkgs && pkgs.length > 0) {

                              SetCataloguePage(1)
                            } else {
                              SetCataloguePage(0)
                            }
                          }}
                        >
                          Back
                        </button>
                        {!weightLocked && grabOrderUpdate && (
                          <button
                            className="bg-theme text-white w-100 b-n corner update-but"
                            id="sub_newreq"
                            onClick={() => updateProduct()}
                          >
                            Submit
                          </button>)}
                        {weightLocked && confirmLockedWeight && grabOrderUpdate && (
                          <button
                            className="bg-theme text-white w-100 b-n corner update-but"
                            id="sub_newreq"
                            onClick={() => updateProduct()}
                          >
                            Submit
                          </button>)}
                      </div>
                    </Row>
                    : ""
              }
            </Modal.Body>
          </Modal>
          :
          //defult
          <Modal
            show={true}
            onHide={handleClose}
            className="updtProPopModal updtProPopModalChooseProduct"
            centered
          >
            <Modal.Header closeButton>
              <div className="fw-bold d-flex justify-contain-start">
                <i className="bi bi-box-seam i-title-icon"></i>
                <div style={{ alignContent: "center" }}>{cataloguePage === 0 ? "Confirm Product Details" : cataloguePage === 1 ? "Confirm Package Details" : "Confirm Price & Stock"}</div>

              </div>
            </Modal.Header>
            <Modal.Body className="updtProPopModal_body p_10px">
              {/* <a class="close mt-1" onClick={() => {
                handleClose()
                props.Popupvisibilityfun(false)
              }}>
                &times;
              </a> */}
              {cataloguePage === 0 ?
                <Row className="">
                  {/* <div className="fw-bold d-flex justify-contain-start">Confirm Product Details</div> */}
                  <ModalHeader img={props?.img} />
                  <div className="d-flex justify-content-end d-flex-responsive">
                    <button
                      className="bg-theme text-white b-n corner update-but-catalogue"
                      id="sub_newreq"
                      onClick={() => confirmProceed()}
                    >
                      Confirm and Proceed
                    </button>
                  </div>
                </Row> : cataloguePage === 1
                  ?
                  <Row className="">
                    <ModalHeader img={props?.img} />
                    <p className="sku mb-2 d-flex justify-contain-start">Package Details</p>
                    <Row className="me-0">
                      <WeightComponent backButton={"Back"} handleSubmit={handleSubmitPackages} handleBackPressWeight={() => SetCataloguePage(0)} />
                    </Row>
                  </Row> : cataloguePage === 2 ?
                    <>
                      <Row>
                        <ModalHeader img={props?.img} />
                      </Row>
                      <Row className="text-center mt-1">
                        <div className="col-12 ">
                          {/* Transfer Price Section */}
                          <div style={confirmPricePopupStyles.formGroup}>
                            <p style={confirmPricePopupStyles.inputLabel}>Transfer Price (incl. {gst}% GST):</p>
                            <input type="number"
                              className="updtProPopModalChooseProductInput"
                              autoComplete="off"
                              value={price}
                              minLength="1"
                              onKeyDown={checkMinusInput}
                              required
                              onChange={(e) => setPrice(e.target.value)}
                              onWheel={(e) => e.target.blur()}
                              style={confirmPricePopupStyles.textInput} />
                            <span
                              className="toastAlert"
                              style={{ display: toastprice }}
                            >
                              <i class="fa fa-exclamation" aria-hidden="true"></i>
                              {priceToastMsg}.
                            </span>
                          </div>

                          {/* GST Section */}
                          <div style={confirmPricePopupStyles.formGroup}>
                            <p style={confirmPricePopupStyles.inputLabel}>Select GST %:</p>
                            <div style={{ position: 'relative' }}>
                              <select
                                value={gst}
                                className="updtProPopModalChooseProductInput"
                                onChange={(e) => changeGST(e.target)}
                              // style={confirmPricePopupStyles.selectInput}
                              >
                                {variables?.variables?.gstValues.map((item, index) => {
                                  return (
                                    <option key={index} value={item}>
                                      {item}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                          </div>

                          {/* Stock Section */}

                          <div style={confirmPricePopupStyles.formGroup}>
                            <p style={confirmPricePopupStyles.inputLabel}>Stock</p>
                            <input
                              type="number"
                              className="updtProPopModalChooseProductInput"
                              value={quantity}
                              autocomplete="off"
                              minLength="1"
                              onKeyDown={checkMinusInput}
                              required
                              onChange={(e) => setquantity(e.target.value)}
                              onWheel={(e) => e.target.blur()}
                              style={confirmPricePopupStyles.textInput} />
                            <span
                              className="toastAlert"
                              style={{ display: stockToast }}
                            >
                              <i class="fa fa-exclamation" aria-hidden="true"></i>
                              {stockToastMsg}.
                            </span>
                          </div>
                        </div>
                      </Row>
                      <div className="d-flex justify-content-end d-flex-responsive">
                        <button
                          className="me-3 text-white w-20 bg-secondary cursor-pointer responsive-btn back-updt-popup"
                          id="sub_newreq"
                          onClick={() => {
                            if (pkgs && pkgs.length > 0) {
                              SetCataloguePage(1)
                            } else {
                              SetCataloguePage(0)
                            }
                          }}
                        >
                          Back
                        </button>
                        {!weightLocked && (
                          <button
                            className="bg-theme text-white w-100 b-n update-but"
                            id="sub_newreq"
                            onClick={() => updateProduct()}
                          >
                            Submit
                          </button>)}
                        {weightLocked && confirmLockedWeight && (
                          <button
                            className="bg-theme text-white w-100 b-n update-but"
                            id="sub_newreq"
                            onClick={() => updateProduct()}
                          >
                            Submit
                          </button>)}
                      </div>
                    </>
                    : ""}

              {/* product weight */}
              {/* {pkgs && pkgs.length > 0 ? (
            <Row className="me-0  pkgCntWrap">
              <div className="">
                <p>No of package</p>
              </div>
              <div>
                <input
                  type="text"
                  value={pkgs.length}
                  className="pkgCnt text-center"
                  disabled
                />
              </div>
              <div>
                <p>(This product comes in {pkgs.length} package)</p>
              </div>
            </Row>
          ) : (
            <></>
          )}

          <Row className="me-0 mt-3">
            {pkgs?.map((item, index) => {
              return (
                <div key={index} className="col-6 pkgDiv">
                  <h6>
                    {index + 1}. {item.productName}
                  </h6>
                  <div className="pkgWrap">
                    {!weightLocked && !item.pkgEdit && (
                      <button
                        className="pkgEdit"
                        onClick={(e) => showPkgEdit(item._id)}
                      >
                        <i class="fa fa-edit" aria-hidden="true"></i>
                      </button>
                    )}
                    <Row className="me-0  mt-5">
                      <div className="col-5">
                        <p>Product Weight</p>
                      </div>
                      <div className="col-7">
                        {item.pkgEdit ? (
                          <>
                            <span>
                              <input
                                type="number"
                                value={item.actualWeight}
                                onKeyDown={checkMinusInput}
                                onChange={(e) =>
                                  handlePkgChange(
                                    item._id,
                                    "actualWeight",
                                    e.target.value
                                  )
                                }
                                className="pkgInpt text-center"
                              />
                              {" Kg"}
                            </span>
                            {item.pkgEdit && item.actualWeight > 0 ? (
                              ""
                            ) : (
                              <>
                                <br />
                                <span class="toastAlert">
                                  {" "}
                                  Please enter a valid weight.
                                </span>
                              </>
                            )}
                          </>
                        ) : (
                          <p>{item.actualWeight} Kg</p>
                        )}
                      </div>
                    </Row>
                    <Row className="me-0 ">
                      <div className="col-5">
                        <p>After Packaging</p>
                      </div>
                      <div className="col-7">
                        {item.pkgEdit ? (
                          <>
                            <span>
                              <input
                                type="number"
                                value={item.weight}
                                onKeyDown={checkMinusInput}
                                onChange={(e) =>
                                  handlePkgChange(
                                    item._id,
                                    "weight",
                                    e.target.value
                                  )
                                }
                                className="pkgInpt text-center"
                              />
                              {" Kg"}
                            </span>
                            {item.pkgEdit && item.weight > 0 ? (
                              ""
                            ) : (
                              <>
                                <br />
                                <span class="toastAlert">
                                  {" "}
                                  Please enter a valid weight.
                                </span>
                              </>
                            )}
                          </>
                        ) : (
                          <p>{item.weight} Kg</p>
                        )}
                      </div>
                    </Row>
                    <Row className="me-0 ">
                      <div className="col-5">
                        <p>Dimensions</p>
                      </div>
                      {item.pkgEdit ? (
                        <>
                          <div className="col-7 d-flex">
                            <span>
                              <input
                                type="number"
                                value={item.packageLengthFront}
                                onKeyDown={checkMinusInput}
                                // maxlength="4"
                                onChange={(e) =>
                                  handlePkgChange(
                                    item._id,
                                    "packageLength",
                                    e.target.value
                                  )
                                }
                                className="dimInpt text-center"
                              />
                              <span> x</span>
                              <input
                                type="number"
                                value={item.packageWidthFront}
                                onKeyDown={checkMinusInput}
                                // maxlength="4"
                                onChange={(e) =>
                                  handlePkgChange(
                                    item._id,
                                    "packageWidth",
                                    e.target.value
                                  )
                                }
                                className="dimInpt text-center"
                              />
                              <span> x</span>
                              <input
                                type="number"
                                value={item.packageHeightFront}
                                onKeyDown={checkMinusInput}
                                // maxlength="4"
                                onChange={(e) =>
                                  handlePkgChange(
                                    item._id,
                                    "packageHeight",
                                    e.target.value
                                  )
                                }
                                className="dimInpt text-center"
                              />
                              {" Ft"}
                            </span>
                          </div>
                          <>
                            {item.pkgEdit &&
                              item.packageHeight > 0 &&
                              item.packageWidth > 0 &&
                              item.packageLength > 0 ? (
                              ""
                            ) : (
                              <>
                                <br />
                                <span class="toastAlert">
                                  {" "}
                                  Please enter a valid dimension(Height, Weicht,
                                  Length).
                                </span>
                              </>
                            )}
                          </>
                        </>
                      ) : (
                        <div className="col-7">
                          <p>
                            {(item.packageLength / 30.48).toFixed(2)} x{" "}
                            {(item.packageWidth / 30.48).toFixed(2)} x{" "}
                            {(item.packageHeight / 30.48).toFixed(2)} Ft{" "}
                          </p>
                        </div>
                      )}
                    </Row>
                  </div>
                </div>
              );
            })}
          </Row>

          <Row className="me-0 my-2 ">
            {weightLocked && (
              <div className="col-12">
                <p className="btmWeightConfirm">
                  {" "}
                  <input
                    type="checkbox"
                    id="weightCheck"
                    checked={confirmLockedWeight}
                    name="weightCheck"
                    // value="Select All"
                    className="mt-2 wCheckbx"
                    onChange={() => setConfirmLockedWeight(!confirmLockedWeight)}
                  />
                  <span>Please confirm the weight details else add a new product here : <a href="http://dseller.toolsvilla.in/form" className="wlink">Add new</a> </span>
                </p>
              </div>
            )}
            {pkgs && pkgs.length > 0 ? (
              <div className="col-12">
                <p className="btmNote">
                  {" "}
                  Note - All the shipments are checked at our courier warehouse
                  and if in case the product weight & dimensions are found
                  different than that given by the logistics company Toolsvilla
                  would debit the seller for the difference. We therefore
                  request you to be careful when entering the weight &
                  dimensions. Thank you!
                </p>
              </div>
            ) : (
              <></>
            )}

            <div className="col-12 fs-14 text-center mt-5">
              {!weightLocked && (
                <button
                  className="bg-theme text-white w-80 b-n py-1 corner mb-2 update-but"
                  id="sub_newreq"
                  onClick={() => updateProduct()}
                >
                  UPDATE
                </button>)}
              {weightLocked && confirmLockedWeight && (
                <button
                  className="bg-theme text-white w-80 b-n py-1 corner mb-2 update-but"
                  id="sub_newreq"
                  onClick={() => updateProduct()}
                >
                  UPDATE
                </button>)}
            </div>
          </Row> */}
            </Modal.Body>
          </Modal >
    );
  }
}


export default UpdtProPopup2;